// extracted by mini-css-extract-plugin
export default {"coloredBoxBanner":"InfoBox_coloredBoxBanner__U5+8x"};